import { useState } from 'react';
import {
  HiCheckCircle,
  HiOutlineInformationCircle,
  HiOutlineExclamation,
  HiOutlineExclamationCircle,
} from 'react-icons/hi';
import Button from '../ui/Buttons/Button';
import Dialog from '../ui/Dialog';
import Input from '../ui/Input';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const StatusIcon = ({ status }) => {
  switch (status) {
    case 'info':
      return (
        <div
          className="bg-blue-100 text-blue-600  rounded-full p-2"
          shape="circle"
        >
          <span className="text-2xl">
            <HiOutlineInformationCircle />
          </span>
        </div>
      );
    case 'success':
      return (
        <div
          className="bg-emerald-100 text-emerald-600  rounded-full p-2"
          shape="circle"
        >
          <span className="text-2xl">
            <HiCheckCircle />
          </span>
        </div>
      );
    case 'warning':
      return (
        <div className="text-amber-600  rounded-full p-2" shape="circle">
          <span className="text-2xl">
            <HiOutlineExclamationCircle />
          </span>
        </div>
      );
    case 'danger':
      return (
        <div
          className="text-red-600 bg-red-100  rounded-full p-2"
          shape="circle"
        >
          <span className="text-2xl">
            <HiOutlineExclamation />
          </span>
        </div>
      );

    default:
      return null;
  }
};

const ConfirmDialog = (props) => {
  const {
    type,
    title,
    children,
    onCancel,
    onConfirm,
    cancelText,
    confirmText,
    typeText,
    loading,
    confirmButtonColor,
    description,
    ...rest
  } = props;
  const [descriptionText, setDescriptionText] = useState('');
  const [typeTextState, setTypeTextState] = useState(false);

  const handleCancel = () => {
    onCancel?.();
  };

  const handleConfirm = () => {
    onConfirm?.(descriptionText);
  };

  return (
    <Dialog
      style={{
        marginTop: 250,
      }}
      contentClassName="pb-0 px-0 max-w-[500px] mx-auto"
      {...rest}
    >
      <div className="px-6 pb-6 pt-2 flex">
        <div>
          <StatusIcon status={type} />
        </div>
        <div className="ml-4 ">
          <h5 className="mb-2 text-lg font-semibold">{title}</h5>
          {children}
          {typeText && (
            <div className="pr-6 mt-6">
              <p className="mb-2">
                Please type <b>"{typeText}"</b> below to confirm deletion.
              </p>
              <div>
                <Input
                  className="!h-10 text-base w-full"
                  type="text"
                  autoComplete="off"
                  onChange={(e) =>
                    setTypeTextState(e.target.value === typeText)
                  }
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {description && (
        <div className="px-6 mb-2">
          <Input
            textArea
            type="text"
            autoComplete="off"
            placeholder="Description"
            onChange={(e) => setDescriptionText(e.target.value)}
          />
        </div>
      )}
      <div className="flex items-center justify-end gap-2 px-6 py-3 bg-gray-100 rounded-b-lg">
        <Button
          disabled={loading}
          size="sm"
          onClick={handleCancel}
          className="!rounded-lg h-8 px-2"
        >
          {cancelText}
        </Button>
        <Button
          disabled={typeText ? !typeTextState : false}
          loading={loading}
          size="sm"
          variant="secondary"
          onClick={handleConfirm}
          className={classNames('!rounded-lg h-8 px-2', confirmButtonColor)}
        >
          {confirmText}
        </Button>
      </div>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  type: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),
};

ConfirmDialog.defaultProps = {
  type: 'info',
  cancelText: 'Cancel',
  confirmText: 'Confirm',
};

export default ConfirmDialog;
